import { render } from "./Secondary.vue?vue&type=template&id=63e7c386&scoped=true"
import script from "./Secondary.vue?vue&type=script&lang=js"
export * from "./Secondary.vue?vue&type=script&lang=js"

import "./Secondary.vue?vue&type=style&index=0&id=63e7c386&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e7c386"]])

export default __exports__